export default __webpack_public_path__ + "static/media/download.64bc54ff.svg";